export default __webpack_public_path__ + "static/media/hero-404.f94381d8.svg";